<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#68D389" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap align-center py-4>
          <v-flex xs12 sm6 text-left>
            <span style="font-family: poppinsbold; font-size: 20px">Feedback by Year</span>
          </v-flex>
          <v-flex xs12 sm6 text-right>
            <v-btn small depressed color="#68D389" dark :loading="excelLoading" @click="downloadYearlyExcel()">
              <v-icon left small>mdi-microsoft-excel</v-icon>Download Excel
            </v-btn>
          </v-flex>
          <v-flex xs12 pt-4>
            <v-layout wrap v-if="yearlyCounts && yearlyCounts.length">
              <v-flex xs6 sm3 md2 pa-2 v-for="(yc, yi) in yearlyCounts" :key="'yc' + yi">
                <v-card outlined class="pa-3 text-center" style="border-color:#68D389">
                  <div style="font-family: poppinsbold; font-size: 24px; color:#2E7D32">{{ yc.count }}</div>
                  <div style="font-family: poppinsregular; font-size: 14px">{{ yc.year }}</div>
                  <v-btn x-small text color="green" class="mt-1" @click="downloadYearlyExcel(yc.year)">
                    <v-icon x-small left>mdi-download</v-icon>{{ yc.year }} details
                  </v-btn>
                </v-card>
              </v-flex>
              <v-flex xs6 sm3 md2 pa-2>
                <v-card flat class="pa-3 text-center" color="#F1F8E9">
                  <div style="font-family: poppinsbold; font-size: 24px; color:#1B5E20">{{ yearlyTotal }}</div>
                  <div style="font-family: poppinsregular; font-size: 14px">Total</div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout wrap v-else>
              <v-flex xs12 text-left>
                <span style="font-family:poppinsregular">No feedback counts available.</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider class="my-4"></v-divider>
        <v-layout wrap v-if="feedback">
          <v-flex xs12 align-self-center py-4 text-left>
            <span style="font-family: poppinsbold; font-size: 20px">Feedback List</span>
          </v-flex>
          <v-flex xs12 pt-6 v-if="feedback">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left"><b>Ticket</b></th>
                    <th class="text-left"><b>Sent Date</b></th>
                    <th class="text-left"><b>comment</b></th>
                    <th class="text-left"><b>Actions</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="height: 90px" v-for="(item, i) in feedback" :key="i">
                    <td class="text-left">
                      <span v-if="item.ticket">
                        <b>#{{ item.ticket.ticketNo }}</b></span>
                      <span v-else>
                        <b>#{{ item.ticket }}</b></span>
                    </td>
                    <td class="text-left">{{ formatDate(item.addeddate) }}</td>
                    <td class="text-left textr">{{ item.comment }}</td>
                    <td class="text-left">
                      <v-layout wrap>
                        <v-flex xs12 align-self-center text-left v-if="item.ticket !== null">
                          <v-btn plain :to="'FeedbackView?feed=' +
                            item.ticket._id +
                            '&guest=' +
                            item.guest._id
                            ">
                            <v-icon color="green">mdi-eye</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 align-self-center text-left v-else>
                          <v-btn plain>
                            <v-icon color="green">mdi-eye</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
          <v-flex v-else xs12 align-self-center text-left pa-5>
            <span style="font-family:poppinsregular">No Feedbacks found!.</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center v-if="pageCount > 0">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages" :total-visible="7"
            v-model="currentPage" color="#68D389"></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from '../../../store'
export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      feedback: null,
      currentPage: 1,
      pages: 0,
      pageCount: 0,
      yearlyCounts: [],
      yearlyTotal: 0,
      excelLoading: false,
    };
  },
  watch: {
    currentPage() {
      store.commit("changeCurrentPage", this.currentPage);
      this.getData();
    },
  },
  beforeMount() {
    if (store.state.currentPage) {
      this.currentPage = store.state.currentPage;
      this.getData();

    } else this.getData();

    this.getYearlyCounts();
  },
  methods: {
    getYearlyCounts() {
      axios({
        method: "GET",
        url: "feedback/yearlycounts",
        params: {
          status: "completed",
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.yearlyCounts = response.data.data || [];
            this.yearlyTotal = response.data.total || 0;
          }
        })
        .catch(() => {
          this.ServerError = true;
        });
    },

    downloadYearlyExcel(year) {
      this.excelLoading = true;
      var params = { status: "completed" };
      if (year) params.year = year;
      axios({
        method: "GET",
        url: "feedback/yearlycounts/excel",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: params,
        responseType: "blob",
      })
        .then((response) => {
          this.excelLoading = false;
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            const filename = "Feedback_By_Year" + (year ? "_" + year : "") + ".xlsx";
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.msg = "Excel downloaded successfully!";
            this.showSnackBar = true;
          } else {
            this.msg = "No data returned for the Excel report.";
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.excelLoading = false;
          this.ServerError = true;
        });
    },

    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "feedback/getlist",
        params: {
          status: "completed",
          page: this.currentPage,
          count: 20,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.data) {
            this.feedback = response.data.data;
            this.pages = response.data.pages;
            this.pageCount = response.data.count;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(() => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },

    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
  },
};
</script>
